import { jsx, css } from '@emotion/react';

import Link from './oc-link';

const linkStyle = ({ listStyle }) => css`
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  span:first-child:before {
    content: '';
    display: inline-block;
    width: 12px;
    height: 16px;
    background-repeat: no-repeat;
    margin-right: 8px;
  }

  span.pdf:before {
    background-image: url(https://imagecdn.owenscorning.com/ocimages/image/upload/v1605717225/use-everywhere/icons/icon-pdf.svg);
  }

  ${listStyle === true &&
  `
    margin: 0!important;
  `};
`;

const standalone = css`
  display: inline-block;
  margin-top: 16px;
  margin-bottom: 16px;

  .dlText {
    font-size: 16px;
    margin-right: 10px;
  }
`;

const DownloadLink = ({ href, fileType, children, text, listStyle, ...props }) => (
  <a href={href} css={[linkStyle({ listStyle }), text && standalone]} {...props} target="_blank">
    <span className={fileType} /> <span className="dlText">{text}</span> {children}
  </a>
);

export default DownloadLink;
